var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Editor',{attrs:{"api-key":_vm.tinymceApiKey,"init":_vm.options},model:{value:(_vm.messages),callback:function ($$v) {_vm.messages=$$v},expression:"messages"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }